import React from 'react'
import PropTypes from 'prop-types'
import { StaticImage } from 'gatsby-plugin-image'
import { useIntl } from 'react-intl'
import { useTheme } from 'styled-components'

import { Container, Section } from '../styles/PageLayout'
import { TitleM, BodyL, BodyM, BodyS, BodyXS } from '../styles/Typography'
import { UseVoiceControlStyled } from '../styles/components/UseVoiceControlStyled'

/**
 * The use voice control block.
 * @param {ComponentProps} props
 * @param {Boolean} props.isAlexa
 * @param {Boolean} props.isApple
 * @param {Boolean} props.isGoogle
 * @returns {FunctionComponent}
 */
const UseVoiceControl = ({ isAlexa, isApple, isGoogle }) => {
  const intl = useIntl()
  const theme = useTheme()

  return (
    <UseVoiceControlStyled>
      <Section $alignCenter $bgColor={theme.backgroundDark}>
        <Container $column $mobileColumn $alignItems="center" $gap="3rem">
          <TitleM className="title" $color={theme.textLight}>
            {intl.formatMessage({ id: 'block_use_voice_control_title' })}
          </TitleM>
          {isAlexa && (
            <>
              <div className="device-group">
                <div className="device">
                  <div className="img watch">
                    <StaticImage
                      src="https://www.1home.io/xassets/use-voice-control-device-1.webp"
                      alt={intl.formatMessage({ id: 'block_use_voice_control_alt' })}
                      placeholder="none"
                      quality="100"
                    />
                  </div>
                  <BodyL $color={theme.textLight}>{intl.formatMessage({ id: 'block_use_voice_control_smart_watch' })}</BodyL>
                </div>
                <div className="device">
                  <div className="img computer">
                    <StaticImage
                      src="https://www.1home.io/xassets/use-voice-control-device-2.webp"
                      alt={intl.formatMessage({ id: 'block_use_voice_control_alt' })}
                      placeholder="none"
                      quality="100"
                    />
                  </div>
                  <BodyL $color={theme.textLight}>{intl.formatMessage({ id: 'block_use_voice_control_computer' })}</BodyL>
                </div>
              </div>
              <div className="device">
                <div className="img other-devices">
                  <StaticImage
                    src="https://www.1home.io/xassets/use-voice-control-device-3.webp"
                    alt={intl.formatMessage({ id: 'block_use_voice_control_alt' })}
                    placeholder="none"
                    quality="100"
                  />
                </div>
                <BodyL $color={theme.textLight}>{intl.formatMessage({ id: 'block_use_voice_control_voice_assistant_devices' })}</BodyL>
              </div>
            </>
          )}
          {isApple && (
            <div className="device">
              <div className="img other-devices">
                <StaticImage
                  src="https://www.1home.io/xassets/use-voice-control-device-4.webp"
                  alt={intl.formatMessage({ id: 'block_use_voice_control_alt' })}
                  placeholder="none"
                  quality="100"
                />
              </div>
              <BodyL $color={theme.textLight}>{intl.formatMessage({ id: 'block_use_voice_control_voice_assistant_devices' })}</BodyL>
            </div>
          )}
          {isGoogle && (
            <>
              <div className="device-group">
                <div className="device">
                  <div className="img watch">
                    <StaticImage
                      src="https://www.1home.io/xassets/use-voice-control-device-5.webp"
                      alt={intl.formatMessage({ id: 'block_use_voice_control_alt' })}
                      placeholder="none"
                      quality="100"
                    />
                  </div>
                  <BodyL $color={theme.textLight}>{intl.formatMessage({ id: 'block_use_voice_control_smart_watch' })}</BodyL>
                </div>
                <div className="device">
                  <div className="img computer">
                    <StaticImage
                      src="https://www.1home.io/xassets/use-voice-control-device-6.webp"
                      alt={intl.formatMessage({ id: 'block_use_voice_control_alt' })}
                      placeholder="none"
                      quality="100"
                    />
                  </div>
                  <BodyL $color={theme.textLight}>{intl.formatMessage({ id: 'block_use_voice_control_computer' })}</BodyL>
                </div>
              </div>
              <div className="device">
                <div className="img other-devices">
                  <StaticImage
                    src="https://www.1home.io/xassets/use-voice-control-device-7.webp"
                    alt={intl.formatMessage({ id: 'block_use_voice_control_alt' })}
                    placeholder="none"
                    quality="100"
                  />
                </div>
                <BodyL $color={theme.textLight}>{intl.formatMessage({ id: 'block_use_voice_control_voice_assistant_devices' })}</BodyL>
              </div>
            </>
          )}
        </Container>
      </Section>
    </UseVoiceControlStyled>
  )
}

UseVoiceControl.propTypes = {
  isAlexa: PropTypes.bool,
  isApple: PropTypes.bool,
  isGoogle: PropTypes.bool,
}

export default UseVoiceControl
